/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegalAgreementToAcceptResponse
 */
export interface LegalAgreementToAcceptResponse {
    /**
     * Identifier of the published legal agreement version requiring acceptance.
     * @type {string}
     * @memberof LegalAgreementToAcceptResponse
     */
    versionId: string;
}

/**
 * Check if a given object implements the LegalAgreementToAcceptResponse interface.
 */
export function instanceOfLegalAgreementToAcceptResponse(value: object): value is LegalAgreementToAcceptResponse {
    if (!('versionId' in value) || value['versionId'] === undefined) return false;
    return true;
}

export function LegalAgreementToAcceptResponseFromJSON(json: any): LegalAgreementToAcceptResponse {
    return LegalAgreementToAcceptResponseFromJSONTyped(json, false);
}

export function LegalAgreementToAcceptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalAgreementToAcceptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'versionId': json['versionId'],
    };
}

export function LegalAgreementToAcceptResponseToJSON(value?: LegalAgreementToAcceptResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'versionId': value['versionId'],
    };
}

